import { render } from "./stratslistDash.vue?vue&type=template&id=83b4ca58&ts=true"
import script from "./stratslistDash.vue?vue&type=script&lang=ts"
export * from "./stratslistDash.vue?vue&type=script&lang=ts"

import "./stratslistDash.vue?vue&type=style&index=0&id=83b4ca58&lang=scss"

import exportComponent from "/Users/edvardaskostkevicius/WebstormProjects/rv_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__